<template>
  <div v-if="optionItemData.isshow">
    <div
      class="field-item-inputs-cell"
    >
      <a-form-item>
        <a-input
          v-decorator="[
            `input_${index}_${optionItemData.id}`,
            {
              initialValue: optionItemData.showname ? optionItemData.showname :optionItemData.name
            }
          ]"
          :placeholder="optionItemData.name"
          @change="changeVal"
        />
      </a-form-item>
      <!-- <a-checkbox
        :checked="optionItemData.isDefault"
        @change="onChange"
      >
        默认
      </a-checkbox> -->
      <a-form-item>
        <a-checkbox
          :checked="optionItemData.isDefault"
          @change="onChange"
        >
          默认
        </a-checkbox>
      </a-form-item>
      <i
        class="iconfont iconicon-test8"
        @click="delItem"
      />
      <i class="iconfont iconicon-test72" />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    },
    optionItemData: {
      type: Object,
      default () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    },
    defaultVal: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState('universalForm/form', ['infoDatas', 'formDefaultDatas']),
    type () {
      return this.itemData.fieldtype
    }
  },
  methods: {
    onChange (b) {
      const { type } = this
      const boon = b.target.checked
      // this.optionItemData.isDefault = b.target.checked
      this.$set(this.optionItemData, 'isDefault', boon)
      if (type === 'checkbox') {
        if (boon) {
          this.itemData.defaultvalue.push(this.optionItemData.id)
        } else {
          this.itemData.defaultvalue.splice(this.itemData.defaultvalue.indexOf(this.optionItemData.id), 1)
        }
      } else if (type === 'select' || type === 'radio') {
        // this.itemData.options.forEach(item => {
        //   item.isDefault = false
        // })
        if (boon) {
          // this.$set(this.itemData, 'defaultvalue', this.optionItemData.id)
          this.itemData.defaultvalue = this.optionItemData.id
        } else {
          // this.$set(this.itemData, 'defaultvalue', '')
          this.itemData.defaultvalue = ''
        }
      }
    },
    changeVal (val) {
      this.$set(this.optionItemData, 'showname', val.target.value)
    },
    delItem () {
      this.optionItemData.isshow = false
    }
  }
}
</script>
